module.exports = __webpack_public_path__ + "img/dylan_brown.5792d8fc.png";